module.exports = __webpack_public_path__ + "static/media/sleepyDragonzFrame2.338de05d.png";